import { z } from 'zod';

export const ZoneGeomSchema = z.object({
    type: z.string().regex(/^(Multi)?Polygon$/),
    coordinates: z.array(z.array(z.array(z.union([z.number(), z.array(z.number())])))),
});
export type ZoneGeomType = z.infer<typeof ZoneGeomSchema>;

export const ZoneSchema = z.object({
    id: z.coerce.number().nullable(),
    name: z.string().catch('').optional(),
    vehicle_id: z.number().nullable().optional(),
    created: z.string().describe('2023-11-26 17:27:57').optional(),
    map_id: z.number().optional(),
    color: z
        .string()
        .regex(/^#[0-9a-f]{6}$/i)
        .optional(),
    order_by: z.number().catch(0),
    geom: ZoneGeomSchema.optional(), // not save when changing zone item order
    attributes: z.record(z.any()).nullable().optional().catch(null)
});
export type ZoneType = z.infer<typeof ZoneSchema>;

export const ZoneCreateSchema = z.object({
    name: z.string(),
});
export type ZoneCreateType = z.infer<typeof ZoneCreateSchema>;
